import './Onboarding.scss'
import React, { Component } from 'react'
import { Slide } from '@material-ui/core';
import Svort, {
    Status,
    ButtonArrow,
    Instruction,
    BIOSERVER,
} from '@svort/component'
import Match from '../Match/Match'
import Stepper from '../../components/Stepper/Stepper'
import MediaRecorderError from '../../components/MediaRecorderError/MediaRecorderError'
import { isSafariIOs } from '../../utils/utils'
import { Translated } from '../../utils/translated'

class Onboarding extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isMatch: false,
            isSvort: false,
            isSignIn: false,
            login: null,

            isPreview: false,
            photos: [],
            activeStep: 0,

            isCheck: false,
            isFinish: false,
            passportData: null,
            passportPortrait: null,

            isLoading: false,
            isSuccess: false,
            isError: false,
            isMediaRecorderError: false,
            onRetry: () => window.location.reload(),

            status: '',
            transitionDirection: 'left'
        }

        this.initState = this.state;
        this.baseRadius = Math.max(window.outerHeight, window.innerHeight) * 0.45 / 2;
        this.initWebSocket();

        this.OnOrientationChange();
        window.addEventListener('orientationchange', () => this.OnOrientationChange());
    }

    OnOrientationChange() {
        // eslint-disable-next-line default-case
        switch (window.orientation) {
            case -90: this.orientation = -90; break;
            case 90: this.orientation = 90; break;
            case 0: this.orientation = 0; break;
            case 180: this.orientation = 180; break;
        }
    }

    componentDidMount() {
        if (!this.props.location.state?.token) {
            this.setState({
                isError: true,
                status: 'init_error',
                onRetry: () => this.props.history.push('/select-onboarding'),
            });
        } else if (window.MediaRecorder)
            this.setState({
                isMatch: true,
                isDemo: true,
                token: this.props.location.state.token,
            });
        else this.setState({ isMediaRecorderError: true });
    }

    componentWillUnmount() {
        this.closeWebsocket();
    }

    initWebSocket() {
        this.ws = new WebSocket(`wss://${BIOSERVER}/onboarding`);
        this.ws.onopen = () => console.log('onboarding websocket opened');
        this.ws.onclose = (event) => console.debug(`onboarding websocket closed: ${JSON.stringify(event)}`);
        this.ws.onerror = (error) => console.debug(`onboarding websocket error`, error);

        this.ws.onmessage = async (msg) => {
            const message = JSON.parse(msg.data)
            if (message.type === 'ping')
                this.sendMessage({ type: 'pong' });
            else if (message.type === 'get_passport_data')
                this.onPassportData(message);
            else if (message.type === 'validate_register_data')
                this.onValidateRegisterData(message);
            else if (message.status === 'error' && !this.state.isSvort)
                this.onWSerror(message);
        }
    }

    onWSerror(message) {
        const { message: errorMessage } = message;

        this.setState({
            isSvort: false,
            isCheck: false,
            isFinish: false,
            isLoading: false,
            isSuccess: false,
            isError: true,
            status: `server_response_error_${errorMessage}`
        });
    }

    closeWebsocket() {
        if (this.ws) {
            this.ws.close();
            console.log('onboarding WS closed');
        }
    }

    onSvortSuccess = (data) => {
        if (!this.state.isSignIn) {
            this.setState({
                isSvort: false,
                isLoading: true,
                status: 'validating_register_data'
            }, () => {
                if (isSafariIOs()) {
                    const video_rotation = this.orientation === 0 ? 90 : this.orientation === 90 ? 180 : 0;
                    const video_ratio = this.orientation === 0 ? 0.75 : 1.33;

                    this.sendMessage({
                        type: 'validate_register_data',
                        video: data,
                        video_rotation,
                        video_ratio
                    });
                } else {
                    this.sendMessage({
                        type: 'validate_register_data',
                        video: data
                    });
                }
            });
        } else {
            this.setState({
                isSvort: false,
                isSuccess: true,
                status: 'register_success'
            }, () => {
                setTimeout(() => {
                    this.setState({
                        isSuccess: false,
                        isFinish: true,
                        activeStep: 3,
                        transitionDirection: 'left'
                    });
                }, 2000);
                this.closeWebsocket();
            });
        }
    }

    onSvortError = (error, message) => {
        console.log('svort_error:', error, message);
    }

    onSvortRetry = () => {
        this.setState({
            // isSvort: false
            isRetry: true
        }, () => {
            // (!this.ws || this.ws.readyState !== 1) && this.initWebSocket();
            this.setState({
                // isSvort: true,
                isRetry: false,
                transitionDirection: 'right'
            });
        });
    }

    onPhoto = (photos) => {
        this.setState({
            isMatch: false,
            isRetry: false,
            isPreview: true,
            photos: [
                ...photos,
                ...this.state.photos
            ],
            transitionDirection: 'left'
        });
    }

    onPhotoMore = () => {
        this.setState({
            isPreview: false,
            isMatch: true,
            isDemo: false,
            isRetry: true,
            transitionDirection: 'left',
        });
    }

    onPhotoContinue = () => {
        this.setState({
            isPreview: false,
            isLoading: true,
            status: 'analyzing_document',
            onRetry: this.onPassportRetry,
            transitionDirection: 'right'
        }, () => {
            this.sendMessage({ type: 'get_passport_data', photos: this.state.photos });
        });
    }

    onPassportData = (message) => {
        const { status, message: error, data } = message;

        if (status === 'error') {
            const onRetry = error === 'invalid_token' || error === 'token_expired'
                ? this.props.isDummy
                    ? () => this.props.history.push('/init-action', { route: '/feature/document' })
                    : () => this.props.history.push('/select-onboarding')
                : this.state.onRetry;

            this.setState({
                isLoading: false,
                isError: true,
                status: `document_error_${error}`,
                onRetry,
            });
        } else {
            this.setState({
                isLoading: false,
                isSuccess: true,
                status: 'document_success'
            }, () => {
                setTimeout(() => {
                    const { portrait, ...restData } = data;

                    const passportData = Object.entries(restData)
                        .filter(x => ![
                            'documentType',
                            'countryCode',
                            'placeOfBirth',
                            'authoruty',
                        ].includes(x[0]))
                        .map(([key, value]) => ({ name: this.getPassportFieldName(key), value }));

                    this.setState({
                        isSuccess: false,
                        isMatch: false,
                        isCheck: true,
                        passportPortrait: portrait,
                        passportData,
                        transitionDirection: 'left'
                    });
                }, 2000);
            });
        }
    }

    onPassportRetry = () => {
        (!this.ws || this.ws.readyState !== 1) && this.initWebSocket();
        this.setState({
            isError: false,
            isCheck: false,
            isMatch: true,
            isDemo: false,
            // passportData: null,
            // passportPortrait: null,
            photos: [],
            isRetry: true,
            transitionDirection: 'left'
        });
    }

    onPassportContinue = () => {
        this.setState({
            isCheck: false,
            isSvort: true,
            isSignIn: false,
            activeStep: 1,
            transitionDirection: 'right'
        });
    }

    onValidateRegisterData = (message) => {
        const { status, message: error } = message;

        if (status === 'error')
            this.setState({
                isLoading: false,
                isError: true,
                status: `server_response_error_${error}`,
                onRetry: () => {
                    this.setState({
                        isError: false,
                        isSignIn: false,
                        isSvort: true
                    });
                }
            });
        else {
            this.setState({
                isLoading: false,
                isSuccess: true,
                status: 'validating_success'
            }, () => {
                setTimeout(() => {
                    this.setState({
                        isSuccess: false,
                        isSvort: true,
                        isSignIn: true,
                        activeStep: 2,
                    });
                }, 2000);
            });
        }
    }

    sendMessage(data) {
        if (this.ws && this.ws.readyState === 1)
            this.ws.send(JSON.stringify({ token: this.state.token, ...data }));
        else this.onWSerror({ message: 'websocket_closed' });
    }

    getPassportFieldName(key) {
        switch (key) {
            case 'documentType': return 'Document type';
            case 'documentNumber': return 'Document number';
            case 'personalNumber': return 'Personal number';
            case 'validDate': return 'Valid date';
            case 'issueDate': return 'Issue date';
            case 'surname': return 'Surname';
            case 'firstname': return 'Firstname';
            case 'fullname': return 'Full name';
            case 'nationality': return 'Nationality';
            case 'dateOfBirth': return 'Birthdate';
            case 'placeOfBirth': return 'Place of birth';
            case 'authoruty': return 'Authoruty';
            case 'sex': return 'Sex';
            default: return key;
        }
    }

    render() {
        console.log(window.outerHeight, window.innerHeight);

        return (
            <div className='onboarding'>
                {!this.state.isMediaRecorderError && <>
                    <Stepper
                        isShow={!this.props.isDummy}
                        steps={[
                            <Translated id="app.onboarding.step-1" />,
                            <Translated id="app.onboarding.step-2" />,
                            <Translated id="app.onboarding.step-3" />
                        ]}
                        activeStep={this.state.activeStep} />

                    {this.props.isDummy &&
                        <div className='header'>
                            <Translated id="app.document.title" />
                        </div>}
                </>}

                <div className='content'>

                    <Slide in={this.state.isMatch} direction={this.state.isRetry || !this.state.isMatch ? 'right' : 'left'} timeout={{ enter: 800, exit: 500 }} mountOnEnter unmountOnExit>
                        <Match
                            onPassport={this.onPhoto}
                            isOnboarding={true}
                            isDummy={true}
                            isDocument={this.props.isDummy}
                            isDemo={this.state.isDemo} />
                    </Slide>

                    <Slide in={this.state.isSvort} direction={this.state.isSvort ? 'left' : 'right'} timeout={{ enter: 800, exit: 500 }} mountOnEnter unmountOnExit>
                        <div>
                            <Svort
                                isShow={!this.state.isRetry}
                                login={this.state.login}
                                isOnboarding={true}

                                // wsEndpoint={`wss://${window.location.host}/api`}
                                token={this.state.token}

                                registerType={this.props.registerType}
                                loginType={this.props.loginType}
                                operationType={this.state.isSignIn ? 'login' : 'register'}
                                locale={this.props.locale}

                                ws={this.ws}
                                baseRadius={this.baseRadius}

                                onSuccess={this.onSvortSuccess}
                                onError={this.onSvortError}
                                onRetry={this.onSvortRetry}
                            />
                        </div>
                    </Slide>

                    <Slide in={this.state.isPreview} direction={this.state.transitionDirection} timeout={{ enter: 800, exit: 500 }} mountOnEnter unmountOnExit>
                        <div className='preview'>
                            <div className='content'>
                                <div className='document'>
                                    {this.state.photos.map((photo, index) =>
                                        <img key={index} src={`data:image/jpg;base64,${photo}`} alt='document' />
                                    )}
                                </div>
                            </div>

                            <div className='controls-wrapper'>
                                <Instruction
                                    isShow={true}
                                    major={this.state.photos.length > 1
                                        ? "app.document.here-photos"
                                        : "app.document.here-photo"}
                                    minor="app.document.add-more" />

                                <div className='controls'>
                                    <ButtonArrow
                                        text={<Translated id="app.document.continue" />}
                                        onClick={this.onPhotoContinue} />

                                    <ButtonArrow
                                        text={<Translated id="app.document.add-photo" />}
                                        isArrow={false}
                                        isSmall={true}
                                        onClick={this.onPhotoMore} />
                                </div>
                            </div>
                        </div>
                    </Slide>

                    <Slide in={this.state.isFinish || this.state.isCheck} direction={this.state.transitionDirection} timeout={{ enter: 800, exit: 500 }} mountOnEnter unmountOnExit>
                        <div className='finish'>
                            <div className='content'>
                                <div className='portrait'>
                                    <img src={`data:image/jpg;base64,${this.state.passportPortrait}`} alt='portrait' />
                                </div>
                                <div className='summary'>
                                    {this.state.passportData?.map((x, index) =>
                                        <p key={index}><span>{x.name}</span>: {x.value}</p>)}
                                </div>
                            </div>

                            <div className='controls-wrapper'>
                                <Instruction
                                    isShow={true}
                                    major={this.state.isFinish
                                        ? "app.onboarding.finish"
                                        : this.state.isCheck && !this.props.isDummy
                                            ? "app.onboarding.check"
                                            : "app.document.finish"} />

                                {(this.state.isCheck || this.state.isFinish) &&
                                    <div className='controls'>
                                        <ButtonArrow
                                            text={this.props.isDummy || this.state.isFinish
                                                ? <Translated id="app.button.finish" />
                                                : <Translated id="app.button.next" />}
                                            onClick={this.props.isDummy
                                                ? () => this.props.history.push('/feature')
                                                : this.state.isFinish
                                                    ? () => this.props.history.push('/')
                                                    : this.onPassportContinue} />

                                        <ButtonArrow
                                            text={<Translated id="app.button.again" />}
                                            isArrow={false}
                                            isSmall={true}
                                            onClick={this.state.isCheck ? this.onPassportRetry : () => this.setState({ ...this.initState, isMatch: true, isDemo: true })} />
                                    </div>}
                            </div>
                        </div>
                    </Slide>

                    <Slide in={this.state.isMediaRecorderError} direction={this.state.transitionDirection} timeout={{ enter: 800, exit: 500 }} mountOnEnter unmountOnExit>
                        <div>
                            <MediaRecorderError
                                isShow={true} />
                        </div>
                    </Slide>

                    <Status
                        isShow={this.state.isLoading || this.state.isSuccess || this.state.isError}
                        isLoading={this.state.isLoading}
                        isSuccess={this.state.isSuccess}
                        isError={this.state.isError}
                        onRetry={this.state.onRetry}>
                        {this.state.status}
                    </Status>
                </div>
            </div>
        )
    }
}

export default Onboarding
